import React from 'react';

import {
  STATISTITS_STORES as FILTERS_STATISTICS_STORES,
} from '../../orders/filters';

import createChartGroup from '../createChartGroup';

import {
  Groups,
  GroupsWrapper,
  GroupsLoading,
} from '../../../components/Statistics';

import {
  filterCompare,
} from '../filters';

import tests from '../../../helpers/tests';

const GROUPS = [{
  id: 'stores',
  title: 'Stores',
  sorts: [
    'default',
    'valueDsc',
    'valueAsc',
  ],
  charts: [{
    id: 'storesPerOrder',
    label: 'Orders',
    precision: 0,
    title: 'Number of orders per store.',
  }, {
    id: 'storesPerRevenue',
    label: 'Revenue',
    title: 'Revenue per store.',
  }],
}].map(group => createChartGroup(group));

export default ['PageStatistics', {
  id: 'statistics-stores',
  title: 'Stores',
  label: 'Stores',
  path: '/analytics/stores',
  loadUrl: '/statistics/stores',
  skip: [tests.viewerIsNotAdmin],
  getUseFiltersExtra: () => true,
  redirect: [['redirect.unauthorized']],
  filters: [
    filterCompare,
    ...FILTERS_STATISTICS_STORES.map(a => ([a[0], {
      ...a[1],
      // isExtra: false,
      whereSide: 'where',
    }])),
    ...FILTERS_STATISTICS_STORES.map(a => ([a[0], {
      ...a[1],
      id: `b.${a[1].id}`,
      // isExtra: false,
      section: 'topCompare',
      whereSide: 'whereB',
      skip: [
        ...(a[1].skip || []),
        props => !['1', '2'].includes(`${props.searchParams.compare}`),
      ],
    }])),
  ],
  renderStats: (props) => {
    if (!props.data && props.loading) {
      return (
        <GroupsWrapper>
          <GroupsLoading />
        </GroupsWrapper>
      );
    }
    if (!props.data || !props.data.data) {
      return <GroupsWrapper />;
    }
    return (
      <GroupsWrapper loading={props.loading}>
        <Groups {...props} groups={GROUPS} />
      </GroupsWrapper>
    );
  },
}];
